import type {
	CalculationMethod,
} from "types/index";
import { CalculationMethodSchema } from "view/calculationmethods/schema";
import type { AgreementTypeEnum, CalculationMethodInputContainer } from "__generated__/graphql";
import {
	CalculationMethodFormInput,
	CalculationMethodFormOutput,
} from "view/calculationmethods/validation/calculationMethod.zod";

export const convertCalculationMethodToForm = (method: CalculationMethod, agreementType?: AgreementTypeEnum | null) => {
	const schemaForm = CalculationMethodSchema[method.type]?.toForm?.(method, agreementType);

	const baseForm: CalculationMethodFormInput = {
		id: method.id,
		type: method.type,
		price: method.price ?? undefined,
		minimumPrice: method.minimumPrice ?? undefined,
		minimumQuantityPayable: method.minimumQuantityPayable ?? undefined,
		preAgreed: method.preAgreed ?? undefined,
		payableOver: method.payableOver ?? undefined,
		description: method.description ?? undefined,
		customUnit: method.customUnit ?? undefined,
		summary: method.summary ?? undefined,
	};

	return schemaForm ? { ...baseForm, ...schemaForm } : { ...baseForm };
};

export const convertCalculationMethodFormToInput = (form: CalculationMethodFormOutput, agreementType?: AgreementTypeEnum | null) => {
	const schemaInput = form.type ? CalculationMethodSchema[form.type]?.toInput?.(form, agreementType) : undefined;

	const baseInput: Partial<CalculationMethodInputContainer> = {
		type: form.type,
	};

	return schemaInput ? { ...baseInput, ...schemaInput } : { ...baseInput };
};
